module.exports = __webpack_public_path__ + "static/media/Group72.893da30b.png";